import { render } from "./TripPassengersWithTooltip.vue?vue&type=template&id=b4a573b2"
import script from "./TripPassengersWithTooltip.vue?vue&type=script&lang=js"
export * from "./TripPassengersWithTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__